import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a46149a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a46149a')) {
      api.createRecord('6a46149a', component.options)
    } else {
      api.reload('6a46149a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6a46149a&", function () {
      api.rerender('6a46149a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/payment/index.vue"
export default component.exports